import { computed, input } from '@angular/core';
import { Marked } from 'marked';
import { INCOMPLETE_MARKDOWN_LINK_REGEX, MARKDOWN_RENDERER_OPTIONS } from 'AIChatApp/constants/ai-chat.constant';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
function AgentResponseMessageComponent_For_4_Conditional_0_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElement(0, "hr");
} }
function AgentResponseMessageComponent_For_4_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, AgentResponseMessageComponent_For_4_Conditional_0_Conditional_0_Template, 1, 0, "hr");
    i0.ɵɵdomElementStart(1, "div", 3)(2, "div", 4)(3, "a", 5);
    i0.ɵɵdomElement(4, "span", 6);
    i0.ɵɵdomElementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const action_r2 = ctx_r0.$implicit;
    const $index_r3 = ctx_r0.$index;
    i0.ɵɵconditional($index_r3 === 0 ? 0 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵdomProperty("href", action_r2.display_result.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵdomProperty("textContent", action_r2.display_result.title);
} }
function AgentResponseMessageComponent_For_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, AgentResponseMessageComponent_For_4_Conditional_0_Template, 5, 3);
} if (rf & 2) {
    const action_r2 = ctx.$implicit;
    i0.ɵɵconditional(action_r2.display_result ? 0 : -1);
} }
const marked = new Marked({ renderer: { ...MARKDOWN_RENDERER_OPTIONS } });
export class AgentResponseMessageComponent {
    constructor() {
        this.messageText = input.required(...(ngDevMode ? [{ debugName: "messageText" }] : []));
        this.includeResponseProfileImage = input(false, ...(ngDevMode ? [{ debugName: "includeResponseProfileImage" }] : []));
        this.displayActions = input([], ...(ngDevMode ? [{ debugName: "displayActions" }] : []));
        this.messageHtml = computed(() => {
            const cleanedContent = this.messageText().replace(INCOMPLETE_MARKDOWN_LINK_REGEX, '*Creating Link...*');
            return marked.parse(cleanedContent);
        }, ...(ngDevMode ? [{ debugName: "messageHtml" }] : []));
    }
}
AgentResponseMessageComponent.ɵfac = function AgentResponseMessageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentResponseMessageComponent)(); };
AgentResponseMessageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentResponseMessageComponent, selectors: [["ycn-agent-response-message"]], inputs: { messageText: [1, "messageText"], includeResponseProfileImage: [1, "includeResponseProfileImage"], displayActions: [1, "displayActions"] }, decls: 5, vars: 3, consts: [[1, "pt-3", "pr-20", "pb-3", "pl-20", "bg-white", "rounded-4"], [1, "section-ai-response-content"], [1, "ai-md", 3, "innerHTML"], [1, "section-ai-response-link", "mb-2"], [1, "d-flex"], ["target", "_blank", 1, "text-underline", "text-blue", 3, "href"], [1, "text-nowrap", 3, "textContent"]], template: function AgentResponseMessageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵdomElementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵdomElement(2, "div", 2);
        i0.ɵɵrepeaterCreate(3, AgentResponseMessageComponent_For_4_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIndex);
        i0.ɵɵdomElementEnd()();
    } if (rf & 2) {
        i0.ɵɵclassProp("section-ai-response", ctx.includeResponseProfileImage());
        i0.ɵɵadvance(2);
        i0.ɵɵdomProperty("innerHTML", ctx.messageHtml(), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance();
        i0.ɵɵrepeater(ctx.displayActions());
    } }, dependencies: [IconModule], encapsulation: 2, changeDetection: 0 });
